var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78498 20.6292C5.13275 20.6292 3.73843 19.5249 3.29974 18.0142C3.11247 17.3693 3.34257 16.6976 3.69452 16.1257L9.74244 5.09773C11.1594 2.79514 14.5064 2.79514 15.9234 5.09773L21.9713 16.1257C22.3232 16.6976 22.5533 17.3693 22.3661 18.0142C21.9274 19.5249 20.5331 20.6292 18.8808 20.6292H6.78498Z",
    fill: "#7B95AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8329 16.557V16.5995M18.8808 20.6292H6.78498C5.13275 20.6292 3.73843 19.5249 3.29974 18.0142C3.11247 17.3693 3.34257 16.6976 3.69452 16.1257L9.74244 5.09773C11.1594 2.79514 14.5064 2.79514 15.9234 5.09773L21.9713 16.1257C22.3232 16.6976 22.5533 17.3693 22.3661 18.0142C21.9274 19.5249 20.5331 20.6292 18.8808 20.6292Z",
    stroke: "#7B95AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 16.557V16.5995",
    stroke: "#213242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 12.9709V8.13257",
    stroke: "#213242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsInactive);
export default __webpack_public_path__ + "static/media/AlertsInactive.ce656b4c4472088e2468a01a3798dede.svg";
export { ForwardRef as ReactComponent };